import { cn } from '@/lib/utils'

export function StepBadge({ index }: { index: number }) {
  return (
    <span className='flex h-6 w-7 shrink-0 items-center justify-center rounded-xl bg-secondary-500 text-[13px] font-bold text-white'>
      {index}
    </span>
  )
}

export function GuideSteps({
  steps,
  className,
  textClassName,
}: {
  steps: string[]
  className?: string
  textClassName?: string
}) {
  return (
    <ol className={cn('flex flex-col gap-2', className)}>
      {steps.map((step, i) => (
        <li key={step} className='flex items-center gap-2 md:gap-4'>
          <StepBadge index={i + 1} />
          <span
            className={cn(
              'text-sm text-neutral-700 md:text-base',
              textClassName
            )}
          >
            {step}
          </span>
        </li>
      ))}
    </ol>
  )
}

export function GuideExample({
  text,
  code,
  className,
}: {
  text: string
  code: string
  className?: string
}) {
  return (
    <p
      className={cn(
        'rounded-xl bg-primary-100/50 px-4 py-2 text-sm text-neutral-800 md:py-4',
        className
      )}
    >
      💡 {text} <strong className='font-bold text-neutral-900'>{code}</strong>
    </p>
  )
}
